import { StyledButton } from 'components/button/Button.styles';
import styled, { css } from 'styled-components';

export const ScreenAndProtectContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ScreenAndProtectHero = styled.div`
  h1 {
    font-size: 34px;
    margin-bottom: 8px;
  }

  p {
    font-size: 16px;
    margin: 0px;
  }
`;

export const ScreenAndProtectSectionsContainer = styled.div`
  padding: 32px;
`;

export const ScreenAndProtectSection = styled.section`
  h3 {
    font-size: 20px;
    font-weight: 500;
    margin: 0;
    margin-bottom: 24px;
  }

  &:not(:last-child) {
    margin-bottom: 24px;
  }
`;

const buttonStyles = css`
  font-size: 20px;
  font-weight: 600;
  padding: 8px 48px;

  margin-top: 24px;
`;

export const ConfirmProtectionButtonStyled = styled(StyledButton)`
  ${buttonStyles}
`;

export const CancelProtectionButtonStyled = styled(StyledButton)`
  ${buttonStyles}
`;

export const GetProtectionButtonStyled = styled(StyledButton)`
  ${buttonStyles}

  width: fit-content;
  margin: 0 auto;
  margin-top: 24px;
`;
